import * as React from 'react';
import { Prompt } from 'react-router';

interface MessageFunc {
  (): string | boolean;
}

const SmePrompt = ({
  message,
  when,
}: {
  when: boolean;
  message: string | MessageFunc;
}): JSX.Element => {
  return (
    <React.Fragment>
      <Prompt when={when} message={message} />
    </React.Fragment>
  );
};

export default SmePrompt;
